import { render, staticRenderFns } from "./Adverts.vue?vue&type=template&id=0ab255b7&scoped=true&"
import script from "./Adverts.vue?vue&type=script&lang=js&"
export * from "./Adverts.vue?vue&type=script&lang=js&"
import style0 from "./Adverts.vue?vue&type=style&index=0&id=0ab255b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab255b7",
  null
  
)

export default component.exports